<template>
    <Transition name="sidebar-transition">
        <div
            v-show="headerStore.sidebarOpen"
            class="sidebar sidebar--desktop"
            :class="{ 'sidebar--open': headerStore.sidebarOpen }"
            @mouseleave.passive="headerStore.sidebarOpen = false"
        >
            <div class="sidebar-wrapper">
                <nav>
                    <ul>
                        <li
                            v-for="(item, index) in items"
                            :key="`${index}-${item.name}`"
                            class="sidebar__menu-item"
                            :class="{ 'sidebar__menu-item--active': activeIndex === index }"
                            @mouseenter.passive="setActiveIndex(index)"
                            @mouseleave.passive="setActiveIndex(null)"
                        >
                            <DynamicLink :path="item.linkUrl" :blank="item.blank" :is-external="item.isExternal">
                                {{ item.name }}
                                <SvgIcon name="arrow-right" :size="16" />
                            </DynamicLink>
                            <Transition name="sidebar-transition">
                                <ul v-if="item.items?.length" v-show="activeIndex === index" class="sidebar__submenu">
                                    <li
                                        v-for="(subItem, subItemIndex) in item.items"
                                        :key="`${subItemIndex}-${subItem.name}`"
                                    >
                                        <DynamicLink :path="subItem.linkUrl" :blank="item.blank" :is-external="item.isExternal">
                                            {{ subItem.name }}
                                            <SvgIcon name="arrow-right" :size="16" />
                                        </DynamicLink>
                                    </li>
                                </ul>
                            </Transition>
                        </li>
                    </ul>
                </nav>
                <Accordion>
                    <AccordionTab v-if="menu?.information?.length" :open="false">
                        <template #headline> Informace </template>
                        <template #icon-toggle>
                            <SvgIcon class="accordion-tab__icon" name="arrow-down" :size="16" />
                        </template>
                        <DynamicLink v-for="(link, index) in menu.information" :key="index" :path="link.linkUrl" :blank="link.blank" :is-external="link.isExternal">
                            {{ link.name }}
                        </DynamicLink>
                    </AccordionTab>
                    <AccordionTab
                        v-for="(footerItem, index) in footerItems.slice(1)"
                        :key="`${index}-${footerItem.name}`"
                        :open="false"
                    >
                        <template #headline> {{ footerItem.name }} </template>
                        <template #icon-toggle>
                            <SvgIcon class="accordion-tab__icon" name="arrow-down" :size="16" />
                        </template>
                        <ul>
                            <li
                                v-for="(footerItemLink, footerItemLinkIndex) in footerItem.items"
                                :key="`${index}-${footerItemLinkIndex}-${footerItemLink.name}`"
                            >
                                <DynamicLink :path="footerItemLink.linkUrl" :blank="footerItemLink.blank" :is-external="footerItemLink.isExternal">{{ footerItemLink.name }}</DynamicLink>
                            </li>
                        </ul>
                    </AccordionTab>
                </Accordion>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import Accordion from "@/shared/components/organisms/Accordion.vue";
import AccordionTab from "@/shared/components/molecules/AccordionTab.vue";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import DynamicLink from "@/shared/components/atoms/DynamicLink.vue";

import useNavigation from "@/shared/composables/use-navigation";
import { useHeader } from "@/shared/stores/use-header";

import { MenuItem } from "@/api/interfaces/menu";

const props = defineProps<{
    items: MenuItem[];
    footerItems: MenuItem[];
}>();

const headerStore = useHeader();
const { menu } = useNavigation();

const activeIndex = ref(null);

const setActiveIndex = (index: number) => {
    activeIndex.value = index;
};

const sidebarClose = () => {
    if (headerStore.sidebarOpen) {
        headerStore.sidebarOpen = false;
    }
};

watch(
    () => headerStore.sidebarOpen,
    (newValue) => {
        newValue
            ? document.addEventListener("scroll", sidebarClose, { passive: true })
            : document.removeEventListener("scroll", sidebarClose);
        if (!newValue) {
            setActiveIndex(null);
            return;
        }

        const kurzoveSazkyItem = props.items.indexOf(
            props.items.find((item) => item.linkUrl.includes("/kurzove-sazky")),
        );

        if (kurzoveSazkyItem !== -1) {
            setTimeout(() => setActiveIndex(kurzoveSazkyItem), 300);
        }
    },
);
</script>
